import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import { Suspense } from 'react';
import { useParams } from 'wouter';

import * as InteractiveComponents from '../../interactives';
import NotFoundPage from './NotFoundPage';

import styles from '../../styles/pages/ai-page.module.css';

interface AiPageProps {
    current?: boolean;
    entered?: boolean;
    entering?: boolean;
    leaving?: boolean;
    paused?: boolean;
    className?: string | null;
    contentClassName?: string | null;
    onEnter?: () => void;
    onLeave?: () => void;
}

function AiPage({
    entered = false,
    entering = false,
    leaving = false,
    current = false,
    paused = false,
    className = null,
    contentClassName = null,
    onEnter = null,
    onLeave = null,
}: AiPageProps): JSX.Element | null {
    const { slug } = useParams<{ slug: string }>();
    const InteractiveComponent = getComponentFromName(InteractiveComponents, `ai-${slug}`);

    if (InteractiveComponent === null) {
        return (
            <NotFoundPage
                current={current}
                className={className}
                contentClassName={contentClassName}
            />
        );
    }

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.entered]: entered,
                    [styles.entering]: entering,
                    [styles.leaving]: leaving,
                },
                className,
                contentClassName,
            ])}
            data-brand="urbania"
            data-theme="dark"
        >
            <Suspense fallback={null}>
                <InteractiveComponent
                    paused={!current || paused}
                    onEnter={onEnter}
                    onLeave={onLeave}
                    className={styles.interactive}
                />
            </Suspense>
        </div>
    );
}

export default AiPage;
